<table class="table table-bordered table-striped table-hover" id="excel-table">
    <thead class="thead-dark">
        <tr>
            <th translate class="header-float row-float-total row-table-head">
                {{'rmpv.analiseMargem.titulo'}}
            </th>
            <!-- <th class="text-right header-float" *ngFor="let mesRef of meses">
                {{mesRef}}
            </th> -->
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.jan'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.fev'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.mar'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.abr'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.mai'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.jun'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.jul'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.ago'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.set'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.out'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.nov'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseMargem.meses.dez'}}
            </th>
            <th class="text-right header-float">
                Total
            </th>
            <th class="text-right header-float">
                % Total
            </th>
            <th class="text-right header-float">
                Total {{anoFiltro - 1}}
            </th>
            <th class="text-right header-float">
                Total {{anoFiltro - 2}}
            </th>
        </tr>
    </thead>
    <tbody>
        <!-- MARGEM MO -->
        <tr *ngFor="let categoria of dados.margem_mo.linhas">
            <!-- <td class="dark-row row-float-total">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right dark-row">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <tr *ngFor="let categoria of dados.margem_peca.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseMargem.totalMargemBrutaPeças'}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_peca.total.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{dados.margem_peca.total.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.margem_peca.total.total_ano_anterior | currency:' '}}
            </td>
            <td class="text-right dark-row">{{dados.margem_peca.total.total_ano_retrasado | currency:' '}}
            </td>
        </tr>
        <!-- MARGEM ACESSÓRIO -->
        <tr *ngFor="let categoria of dados.margem_acessorio.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseMargem.totalMargemAcessorio'}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.margem_acessorio.total.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">
                {{dados.margem_acessorio.total.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">
                {{dados.margem_acessorio.total.total_ano_anterior | currency:' '}}
            </td>
            <td class="text-right dark-row">
                {{dados.margem_acessorio.total.total_ano_retrasado | currency:' '}}
            </td>
        </tr>
        <!-- MARGEM CLOTHING-->
        <tr *ngFor="let categoria of dados.margem_clothing.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <!-- MARGEM OUTROS -->
        <tr *ngFor="let categoria of dados.margem_outros.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <!-- BONUS PCA -->
        <tr *ngFor="let categoria of dados.bonus_pca.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <!-- MARGEM BRUTA TOTAL PCA -->
        <tr>
            <td [translate]="getTranslate(dados.total_margem_bruta_pca.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{dados.total_margem_bruta_pca.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.total_ano_anterior | currency:' '}}
            </td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_pca.total_ano_retrasado | currency:' '}}
            </td>
        </tr>
        <!-- MARGEM BRUTA TOTAL MO + PCA -->
        <tr>
            <td [translate]="getTranslate(dados.total_margem_bruta_mopca.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{dados.total_margem_bruta_mopca.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.total_ano_anterior | currency:' '}}
            </td>
            <td class="text-right dark-row">{{dados.total_margem_bruta_mopca.total_ano_retrasado | currency:' '}}
            </td>
        </tr>
        <!-- % MARGEM BRUTA MO + PCA -->
        <tr>
            <td [translate]="getTranslate(dados.percentual_margem_bruta_mo_pca.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.percentual | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.total_ano_anterior | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_margem_bruta_mo_pca.total_ano_retrasado | percent: '1.1'}}
            </td>
        </tr>
        <!-- DESPESA DEPARTAMENTAL-->
        <tr *ngFor="let categoria of dados.despesa_departamental.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <!-- % DESPESAS -->
        <tr>
            <td [translate]="getTranslate(dados.percentual_despesa_departamental.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.percentual | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.total_ano_anterior | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_despesa_departamental.total_ano_retrasado | percent: '1.1'}}
            </td>
        </tr>
        <!-- RESULTADO OPERACIONAL PV -->
        <tr>
            <td [translate]="getTranslate(dados.resultado_operacional_pv.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{dados.resultado_operacional_pv.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.total_ano_anterior | currency:' '}}
            </td>
            <td class="text-right dark-row">{{dados.resultado_operacional_pv.total_ano_retrasado | currency:' '}}
            </td>
        </tr>
        <!-- % DESPESAS -->
        <tr>
            <td [translate]="getTranslate(dados.percentual_resultado_operacional.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.percentual | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.total_ano_anterior | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_resultado_operacional.total_ano_retrasado | percent: '1.1'}}
            </td>
        </tr>
        <!-- DESPESA ADMINISTRATIVA-->
        <tr *ngFor="let categoria of dados.despesa_administrativa.linhas">
            <!-- <td class="row-float">{{categoria.descricao}}</td> -->
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <!-- RESULTADO OPERACIONAL PV -->
        <tr>
            <td [translate]="getTranslate(dados.percentual_taxa_absorcao.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.percentual | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.total_ano_anterior | percent: '1.1'}}
            </td>
            <td class="text-right percentual">{{dados.percentual_taxa_absorcao.total_ano_retrasado | percent: '1.1'}}
            </td>
        </tr>
        <tr>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    </tbody>
</table>